import { render, staticRenderFns } from "./AscRelatedMxRecsWrapper.vue?vue&type=template&id=9aad8180&"
import script from "./AscRelatedMxRecsWrapper.vue?vue&type=script&lang=js&"
export * from "./AscRelatedMxRecsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscRelatedMxRecsWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports